import { scan_barcode } from '../../../../backbone-unorganized/utils/barcodes';
import { WizardStepPage } from '../WizardStepPage/view';
import { isWeb } from '../../../../shared/utils/is';
import { LorawanDeviceStepView } from './LorawanDeviceStepView/view';
import { MonnitDeviceStepView } from './MonnitDeviceStepView/view';
import { ReactPageWrapper } from '../../../shared/views/ReactPageWrapper';
import { BarcodeScanner } from '@zenput/feature-zencam';

export const DeviceBarcodeStepView = WizardStepPage.extend({
    template: '#tpl_device_barcode_step',
    stepTitleKey: 'mobile_sensors_device_barcode_information',
    selectedManufacturer: null,

    events: {
        'click .scan_barcode': 'scanBarcode',
        'click .enter_barcode_manually': 'enterBarcodeManually'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        DeviceBarcodeStepView.__super__.initialize.apply(this, arguments);

        if (
            this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.SENET ||
            this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.MACHINEQ
        ) {
            this.stepTitleKey = 'mobile_sensors_device_eui_information';
        }

        if (this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.MONNIT) {
            this.stepTitleKey = 'mobile_sensors_device_barcode_information';
        }
    },

    templateHelpers: function () {
        return {
            ...DeviceBarcodeStepView.__super__.templateHelpers.apply(this, arguments),
            image_filename: this._getDeviceScanningImage(),
            scan_code_text: _t('mobile_sensors_scan_qrcode')
        };
    },

    scanBarcode: async function () {
        if (isWeb()) {
            this.openReactBarcodeScanner();
            return false;
        }

        const scanResult = await scan_barcode();
        if (!scanResult) {
            return false;
        }
        this.model.update_barcode_value(scanResult, this.selectedManufacturer);
        this.displayAddDeviceManually();
        return false;
    },

    openReactBarcodeScanner: function () {
        const onScanSuccess = (scanResult) => {
            this.model.update_barcode_value(scanResult, this.selectedManufacturer);
            this.displayAddDeviceManually();
        };

        $f.mobile.nav.show_modal(ReactPageWrapper, {
            renderFunction: function () {
                return (
                    <BarcodeScanner
                        onResultCallback={(result) => {
                            if (result != null) {
                                onScanSuccess(result);
                            }
                            this.close();
                        }}
                    />
                );
            }
        });
        return;
    },

    enterBarcodeManually: function () {
        this.displayAddDeviceManually();
    },

    _getDeviceScanningImage: function () {
        if (
            this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.SENET ||
            this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.MACHINEQ
        ) {
            return 'laird_device_barcode.svg';
        }

        return 'device_barcode.svg';
    },

    _getBarcodeViewClass: function () {
        return this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.SENET ||
            this.selectedManufacturer === $f.mobile.sensors.util.INTEGRATION_TYPE.MACHINEQ
            ? LorawanDeviceStepView
            : MonnitDeviceStepView;
    },

    displayAddDeviceManually: function () {
        const scanDeviceStepView = this._getBarcodeViewClass();

        return $f.mobile.nav.show(scanDeviceStepView, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey,
            selectedManufacturer: this.selectedManufacturer
        });
    }
});
